import * as R from 'ramda'
import urlJoin from 'url-join'
import * as RE from 'helpers/ramda-ext'

const queryToString = R.pipe(
  R.toPairs,
  R.intersperse('&'),
  R.map(R.intersperse('=')),
  R.flatten,
  R.join('')
)

export const concatQueryPathname = RE.whenIsObject(R.pipe(
  RE.removeNilAndEmpty,
  R.when(
    R.has('query'),
    R.pipe(
      R.over(R.lensProp('pathname'), R.concat(R.__, '?')),
      R.over(R.lensProp('query'), queryToString)
    )
  ),
  R.values,
  R.join('')
))

// type ToHref = ({ pathname: string, query: QueryObject }, ?{ [string]: string }) => string
export const toHref = ({ pathname, query = {} }, queryURL = {}) => concatQueryPathname({
  pathname,
  query: {
    ...R.pick(['lc', 'partner', 'marketId', 'theme', 'transportation'], queryURL),
    ...query
  }
})

// type IsOldRoute = string[] => (string => boolean)
const isOldRoute = (routes) => R.both(
  R.complement(R.equals('/')),
  R.compose(
    R.contains(R.__, routes),
    R.toLower,
    R.head,
    R.filter(RE.isNotEmpty),
    R.split('/')
  )
)

// type IsOneOfOldRoutes = string => boolean
export const isOneOfOldRoutes = isOldRoute(['init', 'catalog', 'product', 'universes'])
export const isOldProductRoute = isOldRoute(['product'])

// type GetOpeCodeInPathname = string => string
export const getOpeCodeInPathname = R.pipe(
  R.split('/'),
  R.filter(RE.isNotEmpty),
  R.nth(0),
  R.defaultTo(''),
  R.toUpper
)

const safeUrlJoin = R.curry((x, y) => (
  (!x || !y) ? undefined : urlJoin(x, y)
))

export default class PathHelper {
  static toArray (dottedPath) {
    if (typeof dottedPath !== 'string') return null
    return dottedPath.split('.')
  }
}

// type IsUrl = string => boolean
export const isUrl = path => /^(http(s)?:)?\/\//.test(path)

export const concatMediaPathIfNeeded = R.curry((mediaPath, image) => (
  (isUrl(image) ? image : safeUrlJoin(mediaPath, image))
))

// type QueryParamsToOmit = string[] | QueryObject | string
export const getURIWithoutParams = (pathname, query, queryParamsToOmit) => {
  const paramsToOmit = R.cond([
    [R.is(Array), R.identity],
    [R.is(Object), R.keys],
    [R.is(String), R.of],
    [R.T, R.always([])]
  ])(queryParamsToOmit)

  return toHref({
    pathname,
    query: R.omit(
      paramsToOmit,
      query
    )
  })
}

export const getQueryWithArrayParsedParam = (param) => (query) => R.ifElse(
  R.has(param),
  R.compose(
    R.assoc(param, R.__, query),
    R.split(','),
    R.prop(param)
  ),
  R.assoc(param, [])
)(query)

// type UpdateQuery = ({|
//   +query: QueryObject,
//   +replace: string => void,
//   +uri: string
// |}) => (
//   newQuery: ?QueryObject
// ) => void
export const updateQuery = ({ query, replace, uri }) => newQuery => {
  const oldURI = toHref({
    pathname: uri,
    query
  }, query)

  const newURI = toHref({
    pathname: uri,
    query: { ...(query.key && { key: query.key }), ...newQuery }
  }, query)

  if (R.not(R.equals(oldURI, newURI))) {
    replace(newURI)
  }
}
